import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import {Row, Col, Button, DropdownItem} from 'reactstrap';


import  styledMagstimTableWrapper from 'common/controls/StyledMagstimTableWrapper'
import { MagstimHeaderBar, MagstimFetch, magstim_clickHandler, magstim_eventHandler, CurrentLang, isPDA, MagstimDropdown, MagstimTablePatient, MagstimColor, MagstimLoadingSpinner } from "common";

import * as MathUtils from 'common/utils/MathUtils.js';

import { REST_ENDPOINT_PATIENTS } from 'common/ApiEndpoints';
import { ENUM_STATUS_ARCHIVED, ENUM_STATUS_PARENT_ARCHIVED } from 'common/EnumConstants'

class PatientSearch extends React.Component {

	state = {
		tableHeight: isPDA() ?  'calc(100vh - 370px)' : 'calc(100vh - 130px)',
		headerClass: isPDA() ?  'ui-header' : 'ui-header pl-3',
		isLoading:isPDA() ? true : false
	};

	constructor() {
		super();

		this._table = React.createRef();
		this._dropdownStatus = React.createRef();

		window._PatientSearch_initForSelect = this.initForSelect.bind(this);
		window._PatientSearch_search = this.search.bind(this);

		// console.log('PatientSearch : _PatientSearch_initForSelect = ' + window._PatientSearch_initForSelect);
		// console.log('PatientSearch : _PatientSearch_setHeight = ' + window._PatientSearch_setHeight);
		// console.log('PatientSearch : _PatientSearch_search = ' + window._PatientSearch_search);
	}

	onSelectStatus = (id) => {
		magstim_eventHandler('select', 'status', id);
		this._table.current.addFilter('Status', id);

		if (undefined !== this.props.onStatusChange) {
			this.props.onStatusChange(id);
		}
	}

	// eslint-disable-next-line no-unused-vars
	onClickResetFilters = (event) => {
		magstim_clickHandler('reset');
		this._table.current.resetFilters();
		this._dropdownStatus.current.set('Active');
		
		if (this.props.onClickResetFilters) {
			this.props.onClickResetFilters();
		}
	}

	cellClickCallback = (row, column, cell) => {
		if (this.props.cellClickCallback) {
			this.props.cellClickCallback(row, column, cell);
		}
	}

	selectionChangedCallback = (event, isSelected, rows, row) => {
        if(this.props.selectionChangedCallback !== null && this.props.selectionChangedCallback !== undefined){
            this.props.selectionChangedCallback(event, isSelected, rows, row);
        }
    }

	privacyModeChangedCallback = (privacyOn) => {
        if(this.props.privacyModeChangedCallback !== null && this.props.privacyModeChangedCallback !== undefined){
            this.props.privacyModeChangedCallback(privacyOn);
        }
    }

	render() {

		var table = <></>

        // Let the table height to be set as a prop, to override the value set in the state. 
        var tableHeight = this.state.tableHeight;

        if(this.props.tableHeight !== undefined && this.props.tableHeight.length > 0){
            tableHeight = this.props.tableHeight;
        }

		if(this.props.tableClassType !== undefined){
			table = React.createElement(this.props.tableClassType, { ref:this._table,  div_name:"idPatients", cellClickCallback:this.cellClickCallback, selectionChangedCallback:this.selectionChangedCallback, privacyModeChangedCallback:this.privacyModeChangedCallback}, null)
		}else{
			table = <MagstimTablePatient ref={this._table} 
										 div_name="idPatients" 
										 className="ui-fillh" 
										 cellClickCallback={this.cellClickCallback} 
										 selectionChangedCallback={this.selectionChangedCallback} 
										 privacyModeChangedCallback={this.privacyModeChangedCallback}  ></MagstimTablePatient>
		}

		return (
			<Wrapper className="ui-bg ui-bg-no-row-margin ui-fillh" tableHeight={tableHeight}>
				<Row className={this.state.headerClass}>
					<Col>
						<MagstimHeaderBar main_title={CurrentLang().patient_search_list_label} ShowClose={this.props.ShowClose}>

							<MagstimDropdown ref={this._dropdownStatus} onSelect={this.onSelectStatus} icon='far fa-address-card'>
								<DropdownItem key="Active" id={CurrentLang().patient_status_active} active>{CurrentLang().patient_status_active}</DropdownItem>
								<DropdownItem key="Archived" id={CurrentLang().patient_status_archived}>{CurrentLang().patient_status_archived}</DropdownItem>
								<DropdownItem key="divider" divider />
								<DropdownItem key={null} id={null}>{CurrentLang().patient_status_all}</DropdownItem>
							</MagstimDropdown>

							<div className="button-space"></div>

							<Button color="secondary" className="reset-btn d-none d-md-block" onClick={this.onClickResetFilters} >
								<i className="fas fa-redo fa-flip-horizontal"></i>
							</Button>

						</MagstimHeaderBar>
					</Col>
				</Row>

				<Row className="ui-main">
					<Col>
						<MagstimLoadingSpinner isLoading={this.state.isLoading}/>
						<div className="table-area">
							{table}
						</div>
					</Col>
				</Row>
			</Wrapper>
		);
	}

	adjustHeight(heightPx) {
		var retVal = heightPx - 56 - (20 * 2 /* item-margin */);
		// console.log(`PatientSearch.adjustHeight(${heightPx}) retVal=${retVal}`);
		return retVal;
	}

	initForSelect(data, userLanguage, searchTerm) {

		for (var x = 0; x < data.length; x++) {
            if (data[x].Status === ENUM_STATUS_PARENT_ARCHIVED) {
                data[x].Status = ENUM_STATUS_ARCHIVED;
            }
        }

		if(this._table && this._table.current){

			this._table.current.initForSelect(data, undefined, this.props.multiSelect);

			if(searchTerm !== null && searchTerm !== undefined){
				this._table.current.search(searchTerm);
			}

			if(this._dropdownStatus !== null && this._dropdownStatus.current !== null){

                var filter = this._dropdownStatus.current.getValue();

                if(filter === CurrentLang().patient_status_all){
                    filter = '';
                }

				this._table.current.addFilter('Status', filter);
			}else{
				this._table.current.resetFilters();
			}

			if(userLanguage) {
				// eslint-disable-next-line no-undef
				//console.log("set lang");
				localStorage.setItem('language', userLanguage);
			}
		}
	}

	search(searchText) {
		console.log(`search(${searchText})`);
		this._table.current.search(searchText);
	}

	componentDidMount() {
		if ((undefined !== this.props.initParams) && (undefined === this.isInitialised)) {
			console.log(`PatientSearch.componentDidMount props`, this.props);
			console.log(`PatientSearch.componentDidMount state`, this.state);
			this.initForSelect(this.props.initParams);
			this.isInitialised = true;
		}
		else if (process.env.NODE_ENV !== "production") {
			if(!isPDA()){
				this.loadDebugData();
			}
		}
	}

	loadDataFromAPI(queryString, searchTerm){
		var url = REST_ENDPOINT_PATIENTS;

		if ((undefined !== queryString) && (null !== queryString)) {
			url += queryString;
		}

		var apiCall = MagstimFetch.get(url);

        // #1898 - load with empty data first - so we can get the search placeholder. 
        this.initForSelect([], null, searchTerm);

		apiCall.then((data) => {
			this.initForSelect(data, null, searchTerm);
		})
		.catch((error) => {
			this.props.handleError(error);
		})
		.finally(() => {
			this.setState({isLoading:false});
		});		
	}

	loadDebugData() {
		var firstNames = ['Andy', 'John', 'Chris', 'Shelby', 'Jan', 'Rob', 'Tom', 'James', 'Bob', 'Paul', 'Rory', 'Kate', 'Josie', 'Oscar', 'Leo', 'Jacob', 'Jack', 'Noah', 'George', 'Harry', 'Oliver', 'Olivia', 'Amelia', 'Isla', 'Ava', 'Emily', 'Isabella', 'Mia', 'Poppy', 'Ella', 'Lily'];
		var lastNames = ['Smith', 'Roberts', 'Jones', 'Johnson', 'James', 'Roberts', 'Nugent', 'Byrne', 'Lee', 'Taylor', 'Brown', 'Williams'];
		var statuses = ['Active', 'Archived'];

		var patientData = [];
		for (var x = 0; x < 100; x++) {
			var thisLastTreated = null;
			if (Math.random() < 0.8) {
				thisLastTreated = new Date(2018, MathUtils.random(1, 12), MathUtils.random(1, 28), MathUtils.random(0, 23), MathUtils.random(0, 59));
			}
			patientData[x] = {
				PatientIdNum: x.toString(),
				FirstName: firstNames[MathUtils.random(0, firstNames.length - 1)],
				LastName: lastNames[MathUtils.random(0, lastNames.length - 1)],
				DOB: new Date(MathUtils.random(1950, 2000), MathUtils.random(1, 12), MathUtils.random(1, 28)),
				LastTreated: thisLastTreated,
				Status: statuses[MathUtils.random(0, statuses.length - 1)]
			};
		}
		
		this.initForSelect(patientData, "");
	}

}


PatientSearch.propTypes = {
	onStatusChange: PropTypes.func,
	onClickResetFilters: PropTypes.func,
	ShowClose: PropTypes.bool,
    multiSelect: PropTypes.bool,
};

PatientSearch.defaultProps = {
	onStatusChange: undefined,
	onClickResetFilters: undefined,
	ShowClose: false,
    multiSelect:true
};

const Wrapper = styled(styledMagstimTableWrapper)`

	.reset-btn {
		margin-left: 0px;
		margin-right: 15px;
		padding: 0px;
		min-width: 100px;
		background:  ${ MagstimColor.MagstimSecondaryButton};
	}

	.button-space {
		margin-left: 15px;
	
	}
	
	.fa-redo{
		color:${ MagstimColor.MagstimTextForground};
	}

	.table-wrapper {

		.table-scroll {
			
			table thead tr th span i.fa-eye, table thead tr th span i.fa-eye-slash {
				display: block;
				height: 50px;
				line-height: 50px;
				vertical-align: middle;
			}
			
		}
	}
`;


export default  PatientSearch;
